'use client';

import { FC, MouseEvent, useEffect, useRef, useState } from 'react';
import PageBreadcrumbs from '@/components/PageBreadcrumbs';
import { breadcrumbTrails } from '@/lib/breadcrumbs';
import { gsap, ScrollSmoother, ScrollTrigger } from '@/lib/gsap';
import NavigationSidebar from './NavigationSidebar';
import css from './style.module.scss';
interface Props {
  data: {
    heading: {
      title: string;
      subtitle: string;
    };
    content: {
      id: number;
      title: string;
      text: any; // TODO: Change to BlocksContent when cms will be ready
    }[];
  };
}
const PrivacyPolicy: FC<Props> = ({
  data
}) => {
  const {
    heading,
    content
  } = data;
  const [targetId, setTargetId] = useState<string | null>(null);
  const [headings, setHeadings] = useState<any[]>([]);
  const contentRef = useRef<HTMLDivElement>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const smoother = ScrollSmoother.get();
  useEffect(() => {
    if (!contentRef.current) return;
    const h2Elements = contentRef.current?.querySelectorAll('h2');
    const headingsData = h2Elements ? Array.from(h2Elements).map(heading_0 => ({
      id: heading_0.id,
      text: heading_0.textContent,
      url: `#${heading_0.id}`
    })) : [];
    setHeadings(headingsData);
  }, [contentRef.current]);
  useEffect(() => {
    const contentEl = contentRef.current;
    const sidebarEl = sidebarRef.current;
    const ctx = gsap.context(() => {
      if (!contentEl || !sidebarEl) return;
      gsap.to(sidebarEl, {
        scrollTrigger: {
          trigger: contentEl,
          pin: sidebarEl,
          pinSpacing: false,
          start: 'top 80px',
          end: 'bottom bottom'
        }
      });
      const h2Elements_0 = contentEl.querySelectorAll('h2');
      const headings_0 = Array.from(h2Elements_0);
      headings_0.forEach((heading_1, index) => {
        ScrollTrigger.create({
          trigger: heading_1,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => setTargetId(heading_1.id),
          onEnterBack: () => setTargetId(heading_1.id),
          onLeaveBack: () => {
            if (index === 1) setTargetId(headings_0[0].id);
          }
        });
      });
    });
    return () => ctx.revert();
  }, []);
  const handleLinkClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setTargetId(id);
    const section = contentRef.current?.querySelector(`#${id}`);
    if (section) smoother?.scrollTo(section, true, 'center center');
  };
  return <div className={css.wrapper}>
			<div className={css.breadcrumbs}>
				<PageBreadcrumbs items={breadcrumbTrails.privacyPolicy()} withContainer={false} />
			</div>
			<div className={css.heading}>
				<h1 className={css.title}>{heading.title}</h1>
				<p className={css.subtitle}>{heading.subtitle}</p>
			</div>

			<div ref={contentRef} className={css.content}>
				<div className={css.sidebarWrapper}>
					<div ref={sidebarRef} className={css.sidebar}>
						{headings.length > 0 && <NavigationSidebar targetId={targetId} links={headings} handleLinkClick={handleLinkClick} />}
					</div>
				</div>
				<div className={css.contentWrapper}>
					{content.map((item, index_0) => <section key={`content_${index_0}`} className={css.wrapperSection}>
							<h2 id={`heading-${item.id}-${index_0 + 1}`} className={css.contentTitle}>
								{item.title}
							</h2>
							<div className={css.contentText} dangerouslySetInnerHTML={{
            __html: item.text
          }} />
						</section>)}
				</div>
			</div>
		</div>;
};
export default PrivacyPolicy;